<div class="layout-content">
   <div *ngIf="saving">
      <div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
         <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
      </div>
   </div>
   <form (ngSubmit)="submit()" [formGroup]="cloneForm" *ngIf="!saving">
      <div class="grid">
         <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
            <p-tag icon="pi cm-alert" [value]="('MTMA_INFO_NEW_SET_AFTER_SUB' | translate)" severity="warning"
               styleClass="text-lg"></p-tag>
         </div>
         <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
            <p-tag icon="pi cm-alert" [value]="('MTMA_INFO_REPLACE_CHECK_STATUS' | translate)" severity="warning"
               styleClass="text-lg"></p-tag>
         </div>
         <div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
            <p-tag icon="pi cm-alert" [value]="('MTMA_INFO_REPLACE_REMOVE_OLD_DEVICE' | translate)" severity="warning"
               styleClass="text-lg"></p-tag>
         </div>
         <div class="col-12" [ngClass]="customPaddingX()">
            <div class="flex justify-content-between flex-wrap"
               [ngClass]="newShowErrors(this.f.deviceIdTo, 'borderRow')">
               <div class="flex align-items-center justify-content-center"
                  [ngClass]="newShowErrors(this.f.deviceIdTo, 'label')">{{ 'MTMA_CLONE_DESTINATION' | translate }}</div>
               <div class="flex align-items-center justify-content-center"
                  [ngClass]="newShowErrors(this.f.deviceIdTo, 'borderInput')">
                  <p-dropdown [options]="listOtherMtma" optionLabel="Name" [ngClass]="dynamicInputTextWidth()"
                     appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
                     panelStyleClass="text-center" formControlName="deviceIdTo"
                     placeholder="{{ 'MTMA_CLONE_DESTINATION' | translate }}" optionValue="Id" dataKey="Id">
                  </p-dropdown>
               </div>
            </div>
            <small *ngIf="showErrorRequiredMessage(this.f.deviceIdTo)" class="flex align-items-center text-50 pt-1"
               [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
         </div>
      </div>
      <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
         <button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}" [disabled]="cloneForm.invalid"
            class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
         </button>
         <button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
            class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
         </button>
      </div>
   </form>
</div>




<!--<form [formGroup]="cloneForm" (ngSubmit)="submit()">




   <div mat-dialog-content fxLayout="column">
     <mat-form-field fxFlex="100">
         <mat-label>{{ 'MTMA_CLONE_DESTINATION' | translate}}</mat-label>
         <mat-select formControlName="deviceIdTo">
             <mat-option *ngFor="let mtma of listOtherMtma" [value]="mtma.Id">
                {{mtma.Name}}
             </mat-option>
         </mat-select>
     </mat-form-field>
     <div class="alert alert-danger" fxFlex.xs="100">
         {{ 'MTMA_CLONE_WARNING' | translate }}
     </div>
   </div>
   <div mat-dialog-actions class="mat-dialog-actions">
     <button id="buttonCloneCancel" mat-raised-button type="button" (click)="dialogRef.close()">{{ 'CANCEL' | translate }}</button>
     <button id="buttonCloneSave" mat-raised-button type="submit" color="primary" [disabled]="cloneForm.invalid"
       class="btn btn-primary btn-block">{{'SAVE' | translate }}</button>
   </div>
 </form>-->